import { AbstractBlock } from '../AbstractBlock';
import { ShapeSettings } from '../setting/ShapeSettings';
import { ColorSettings } from '../setting/ColorSettings';
import { CodeSetting } from '../setting/CodeSetting';
import { GlobalImport } from '../../utils/GlobalImport';
import { BlockType } from '../../@types/BlockType';
import { block_translation } from '../../lang/BlockTranslation';
const Blockly = GlobalImport.getBlockly();
const t = block_translation;

export class OnClickAttribute extends AbstractBlock {
  constructor() {
    super('onclick_att', t.to('クリックした時', 'on_click'));
  }

  defineBlock(block: BlockType): void {
    ShapeSettings.setAttributeShape(block);
    ColorSettings.setAttributeColor(block);

    const func = new Blockly.FieldTextInput(t.to('ブロック名', 'block_name'));
    block
      .appendDummyInput()
      .appendField(`${t.to('クリックした時に', 'if_on_click')}`)
      .appendField(func, 'func')
      .appendField(`${t.to('を処理する', 'handle_this')}`);
    ShapeSettings.addAttributeInput(block);
  }

  codeGenerateCore(block: BlockType): string[] {
    const attribute = CodeSetting.getSubAttributeCode(block);
    const func = CodeSetting.getFieldValue(block, 'func');

    const str = CodeSetting.buildAttribute([[this.name_for_code, `${func}()`]], attribute);
    return [str];
  }
}
